import { InjectionToken } from '@angular/core';

export interface PlatformConfig {
  platformUrl: string;
}

export const PLATFORM_CONFIG = new InjectionToken<PlatformConfig>('PLATFORM_CONFIG');
